export default "__VITE_ASSET__8b585f7f__"